module.exports = __webpack_public_path__ + "media/images/flags/16/Turkey-4cbdb17304b6aadd01def68bc50aa4c3.png";